const API_BASE =
  process.env.NODE_ENV === "production" ? "/api" : "http://localhost:5000/api";

const API_BASE2 =
  process.env.NODE_ENV === "production"
    ? "/api/notes"
    : "http://localhost:5000/api/notes";

export async function login(password) {
  const res = await fetch(`${API_BASE}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });
  if (!res.ok) throw new Error("Invalid credentials");
  return res.json();
}

export async function getAllTimes() {
  const res = await fetch(`${API_BASE}/prayer-times`);
  if (!res.ok) throw new Error("Failed to load");
  return res.json();
}

export async function getToday(dateStr) {
  const res = await fetch(
    `${API_BASE}/prayer-times/today/${encodeURIComponent(dateStr)}`,
  );
  if (!res.ok) throw new Error("No data for today");
  return res.json();
}

export async function bulkUpdate(data) {
  const token = localStorage.getItem("token");
  const res = await fetch(`${API_BASE}/prayer-times/bulk`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ data }),
  });
  if (!res.ok) {
    const msg = await res.json().catch(() => ({}));
    throw new Error(msg.message || "Update failed");
  }
  return res.json();
}
export async function deletePrayerTime(id) {
  const token = localStorage.getItem("token");
  await fetch(`${API_BASE}/prayer-times/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
}

export function isAuthed() {
  return !!localStorage.getItem("token");
}

// below api is for notes management
// below api is for notes management
// below api is for notes management
// below api is for notes management
// below api is for notes management

export async function getNotes() {
  const res = await fetch(API_BASE2);
  return res.json();
}

export async function addNote(text) {
  const res = await fetch(API_BASE2, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text }),
  });
  return res.json();
}

export async function updateNote(id, text) {
  const res = await fetch(`${API_BASE2}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text }),
  });
  return res.json();
}

export async function deleteNote(id) {
  await fetch(`${API_BASE2}/${id}`, { method: "DELETE" });
}

// below api is for news breaking news
const API_BASE3 =
  process.env.NODE_ENV === "production"
    ? "/api/news"
    : "http://localhost:5000/api/news";

export async function fetchItems() {
  const res = await fetch(`${API_BASE3}`);
  return res.json();
  // console.log(res);
}

export async function createItem(payload) {
  const res = await fetch(`${API_BASE3}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error("Failed to create item");
  return res.json();
}

export async function updateItem(id, payload) {
  const res = await fetch(`${API_BASE3}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error("Failed to update item");
  return res.json();
}

export async function deleteItem(id) {
  const res = await fetch(`${API_BASE3}/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Failed to delete item");
  return res.json();
}

// names api for ramadan//////////////////////////////////////
const API_BASE4 =
  process.env.NODE_ENV === "production" ? "/api" : "http://localhost:5000/api";

export async function fetchSheets() {
  const res = await fetch(`${API_BASE4}/names`);
  return res.json();
}

export async function createSheet(names, phones) {
  const res = await fetch(`${API_BASE4}/names`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ names, phones }),
  });
  return res.json();
}

export async function updateSheet(id, names, phones) {
  const res = await fetch(`${API_BASE4}/names/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ names, phones }),
  });
  return res.json();
}

export async function deleteSheet(id) {
  const res = await fetch(`${API_BASE4}/names/${id}`, {
    method: "DELETE",
  });
  return res.json();
}

////////////////////////////////////////////////

// export async function fetchDocs() {
//   const res = await fetch(`${API_BASE4}/names`);
//   return res.json();
// }

// export async function createDoc(names) {
//   const res = await fetch(`${API_BASE4}/names`, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ names }),
//   });
//   return res.json();
// }

// export async function updateDoc(id, names) {
//   const res = await fetch(`${API_BASE4}/names/${id}`, {
//     method: "PUT",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ names }),
//   });
//   return res.json();
// }

// export async function deleteDoc(id) {
//   const res = await fetch(`${API_BASE4}/names/${id}`, { method: "DELETE" });
//   return res.json();
// }

// transaction for MIC

// const API_BASE = import.meta.env.VITE_API_BASE || "http://localhost:4000";
const API_BASE5 =
  import.meta.env.NODE_ENV === "production"
    ? "/api"
    : "http://localhost:5000/api";

export async function fetchTransactions() {
  const res = await fetch(`${API_BASE5}/transactions`);
  return res.json();
}

export async function createTransaction(formData) {
  const res = await fetch(`${API_BASE5}/transactions`, {
    method: "POST",
    body: formData,
  });
  return res.json();
}

export async function updateTransaction(id, payload) {
  const res = await fetch(`${API_BASE5}/transactions/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function deleteTransaction(id) {
  const res = await fetch(`${API_BASE5}/transactions/${id}`, {
    method: "DELETE",
  });
  return res.json();
}
